import styled from 'styled-components';
import {CommonContent} from './LightHomePage.style';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.div`
  background-color: ${p => p.theme.openingTimeBgColor};
  background-size: cover;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const Content = CommonContent.extend`
  flex-direction: row;
  color: ${p => p.theme.primaryColor};
  padding: 2rem;
  align-items: flex-start;
  ${media.small`
    flex-wrap: wrap;
  `};
`;

export const Block = styled.div`
  flex-basis: 50%;
  display: flex;
  flex-direction: column;
  text-align: left;
  letter-spacing: 0.1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  font-size: 1.8rem;
  ${media.medium`
    padding-left: 1rem;
    padding-right: 1rem;
  `};
  ${media.small`
    font-size: 1.6rem;
    padding-left: 0;
    flex-basis: 100%;
  `};
  table {
    border-collapse: collapse;
    width: 100%;
  }
  tr {
    line-height: 3.6rem;
    border-top: ${p => `0.1rem solid ${p.theme.textColor}`};
  }
  td div {
    text-align: right;
  }
`;

export const Title = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 2rem;
  font-weight: 400;
  line-height: 2.8rem;
  margin: 2rem 0;
  text-transform: uppercase;
`;

export const Text = styled.div`
  font-size: 1.8rem;
  font-weight: 300;
  line-height: 2.8rem;
  white-space: pre-line;
  ${media.small`
    font-size: 1.6rem;
  `};
`;

export const Phone = Text.extend`
  margin: 2rem 0;
`;



// WEBPACK FOOTER //
// ./containers/LightHomePage/FullOpeningTimes.style.js